export const WEBSUMMIT_CONTATO_ROUTE = 'websummit-contato';
export const WEBSUMMIT_PRODUCT_QUERY_PARAM = 'product';

export function isWebsummitContatoUrl(url: string): boolean {
  const path = url.split('?')[0];
  return (
    path === `/${WEBSUMMIT_CONTATO_ROUTE}` ||
    path.endsWith(`/${WEBSUMMIT_CONTATO_ROUTE}`)
  );
}
